import { motion, useAnimationControls, type Transition, type Variants } from 'framer-motion'
import React, { useCallback, useEffect } from 'react'

import { ModalContainerProps } from '@ui/components/Modal/Container'
import {
  MODAL_EXIT_MS,
  useAnimatedModalClose,
} from '@ui/components/Modal/hooks/useAnimatedModalClose'

import styles from './FullScreen.module.scss'

const FULLSCREEN_OPEN_TRANSITION: Transition = { type: 'spring', stiffness: 350, damping: 40 }

const FULLSCREEN_EXIT_TRANSITION: Transition = {
  type: 'tween',
  duration: MODAL_EXIT_MS / 1000,
  ease: [0.2, 0.0, 0.2, 1],
}

const fullScreenVariants: Variants = {
  initial: { y: '100%' },
  animate: { y: '0%', transition: FULLSCREEN_OPEN_TRANSITION },
  exit: { y: '100%', transition: FULLSCREEN_EXIT_TRANSITION },
}

export const FullScreen: React.FC<ModalContainerProps> = ({ children, background }) => {
  const controls = useAnimationControls()

  useEffect(() => {
    controls.set('initial')
    controls.start('animate')
  }, [controls])

  const playExit = useCallback(() => controls.start('exit'), [controls])

  useAnimatedModalClose(playExit)

  return (
    <motion.div
      className={styles.fullScreen}
      variants={fullScreenVariants}
      style={{ background }}
      initial='initial'
      animate={controls}
    >
      {children}
    </motion.div>
  )
}
